import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PoDialogService, PoNotificationService } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { firstValueFrom, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { environment } from 'src/environments/environment';
import { ISellerAPI, Seller } from '../interfaces/seller.model';
import { LiteralsService } from './literals-service';

@Injectable({
    providedIn: 'root'
})
export class SellersService {
    sellerTable = 'seller';
    literals: LiteralsWords;

    constructor(
        private http: HttpClient,
        private poStorageService: PoStorageService,
        private poNotificationService: PoNotificationService,
        private poDialog: PoDialogService,
        private literalsService: LiteralsService
    ) {
        this.literals = this.literalsService.getLiteralModule();
    }

    getSeller(page = 1, pageSize = 1): Observable<ISellerAPI> {
        return this.http.get<ISellerAPI>(
            `${environment.url}api/tgv/sellers/codeuser?page=${page}&pageSize=${pageSize}`
        );
    }

    async setSeller(): Promise<ISellerAPI> {
        const data$ = this.getSeller(1, 1).pipe(take(1));
        return await firstValueFrom(data$).then(
            async seller =>
                await this.poStorageService.set(this.sellerTable, seller)
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setSellerToStorage(seller: ISellerAPI): Promise<any> {
        return this.poStorageService.set(this.sellerTable, seller);
    }

    getSellerStorage(): Promise<ISellerAPI> {
        return this.poStorageService.get(this.sellerTable);
    }

    async existSeller(): Promise<ISellerAPI | void> {
        return await this.poStorageService
            .exists(this.sellerTable)
            .then(async exist => {
                if (exist) {
                    return await this.getSellerStorage();
                }
                return null;
            })
            .catch(error => {
                this.poNotificationService.error(error);
            });
    }

    removeSeller(): Promise<void> {
        return this.poStorageService.remove(this.sellerTable);
    }

    async changeSeller(): Promise<ISellerAPI> {
        const seller = await this.existSeller();
        if (seller) {
            await this.removeSeller();
            return await this.setSeller();
        } else {
            return await this.setSeller();
        }
    }

    isSeller(seller: Seller): boolean {
        if (!seller.isseller) {
            this.poDialog.alert({
                title: this.literals.str0650,
                message: this.literals.str0649
            });
        }
        return seller.isseller;
    }

    canAccessProtectedData(seller: Seller): boolean {
        if (!seller.canaccessprotecteddata) {
            this.poDialog.alert({
                title: this.literals.str0503, // Acesso negado
                message: this.literals.str0505 // Usuario não possui accesso a dados sensiveis ou pessoais
            });
        }
        return seller.canaccessprotecteddata;
    }

    canSellerAccess(seller: Seller): boolean {
        return this.isSeller(seller) && this.canAccessProtectedData(seller);
    }
}
